import React from 'react';
import slider_logo from '../../assets/img/slider/slider_logo.svg';
import slider_logo1 from '../../assets/img/slider/slider_logo1.svg';
import slider_logo2 from '../../assets/img/slider/slider_logo2.svg';

// Import Swiper React components
import {Swiper, SwiperSlide} from 'swiper/react';

// Import Swiper styles
import 'swiper/swiper.min.css';

import SwiperCore, {
	Autoplay,
	Pagination,
	Navigation,
	EffectCoverflow,
} from 'swiper';

import {useTranslation} from 'react-i18next';
import {formatNumber} from '../../assets/utils/utils';
import {UserStat1Type} from '../../types/TypesUser';
import s from './Slider.module.css';
import {currentMonthName} from '../../assets/utils/dateUtils';

// install Swiper modules
SwiperCore.use([Autoplay, Pagination, Navigation, EffectCoverflow]);

type Props = {
	statData: UserStat1Type;
	textPoints: string;
	userPoints: string;
	checkPoints: string;
	bonusMoney: string;
	childPoints: string;
	countChild1p: string;
	countChild: string;
	countActive: string;
};

const SliderSwiper: React.FC<Props> = ({
	statData,
	textPoints,
	userPoints,
	checkPoints,
	bonusMoney,
	childPoints,
	countChild1p,
	countChild,
	countActive,
}) => {
	const {t} = useTranslation();
	const monthName = currentMonthName();
	return (
		<div className={s.pageSlider}>
			<div className={s.sliderTotal}>
				<div className={s.sliderBody}>
					<Swiper
						spaceBetween={16}
						centeredSlides
						navigation
						slidesPerView={3}
						breakpoints={{
							320: {slidesPerView: 1, spaceBetween: 8, centeredSlides: false},
							480: {slidesPerView: 2, spaceBetween: 8},
							550: {slidesPerView: 3, spaceBetween: 8},
							768: {slidesPerView: 3, spaceBetween: 14},
							1024: {slidesPerView: 3, spaceBetween: 14},
						}}
						loop={true}
						effect="coverflow"
						coverflowEffect={{
							rotate: 0,
							stretch: 0,
							depth: 200,
							modifier: 1,
							slideShadows: true,
						}}
						watchOverflow={true}
						autoplay={{
							delay: 8000,
							disableOnInteraction: false,
						}}
						pagination={{
							clickable: true,
						}}
						className="mySwiper"
					>
						{/* User Points */}
						<SwiperSlide>
							<div className={s.sliderItem}>
								<div className={s.sliderTop}>
									<div className={s.sliderLogo}>
										<img src={slider_logo} alt="slider_logo" />
									</div>
									<div className={s.sliderDate}>{monthName}</div>
								</div>
								<div className={`${s.sliderRate} ${s.sliderRateGreen}`}>
									{formatNumber(statData.user_points)}
									<span>{textPoints}</span>
								</div>
								<div className={s.sliderBottom}>
									<div className={s.sliderVolume}>{userPoints}</div>
									<div className={s.sliderLines}>
										<span></span>
									</div>
								</div>
								<div className={`${s.sliderBg} ${s.sliderBg01}`}></div>
							</div>
						</SwiperSlide>

						{/* Child Points */}
						<SwiperSlide>
							<div className={`${s.sliderItem} ${s.sliderItemGreen}`}>
								<div className={s.sliderTop}>
									<div className={s.sliderLogo}>
										<img src={slider_logo2} alt="slider_logo" />
									</div>
									<div className={`${s.sliderDate} ${s.sliderDateGreen}`}>
										{monthName}
									</div>
								</div>
								<div className={`${s.sliderRate} ${s.sliderRateGreen}`}>
									{formatNumber(statData.child_points)}
									<span>{textPoints}</span>
								</div>
								<div className={s.sliderBottom}>
									<div className={s.sliderVolume}>{childPoints}</div>
									<div className={s.sliderLines}>
										<span></span>
									</div>
								</div>
								<div className={`${s.sliderBg} ${s.sliderBg02}`}></div>
							</div>
						</SwiperSlide>

						{/* Check Points */}
						<SwiperSlide>
							<div className={`${s.sliderItem} ${s.sliderItemBlue}`}>
								<div className={s.sliderTop}>
									<div className={s.sliderLogo}>
										<img src={slider_logo1} alt="slider_logo" />
									</div>
									<div className={`${s.sliderDate} ${s.sliderDateBlue}`}>
										{monthName}
									</div>
								</div>
								<div className={`${s.sliderRate} ${s.sliderRateGreen}`}>
									{formatNumber(statData.check_points)}
									{/*<span>{t('Бонусів')}</span>*/}
								</div>
								<div className={s.sliderBottom}>
									<div className={s.sliderVolume}>{checkPoints}</div>
									<div className={s.sliderLines}>
										<span></span>
									</div>
								</div>
								<div className={`${s.sliderBg} ${s.sliderBg03}`}></div>
							</div>
						</SwiperSlide>

						{/* Count Child 1p */}
						<SwiperSlide>
							<div className={`${s.sliderItem} ${s.sliderItemGreen}`}>
								<div className={s.sliderTop}>
									<div className={s.sliderLogo}>
										<img src={slider_logo2} alt="slider_logo" />
									</div>
									<div className={`${s.sliderDate} ${s.sliderDateGreen}`}>
										{monthName}
									</div>
								</div>
								<div className={`${s.sliderRate} ${s.sliderRateGreen}`}>
									{formatNumber(statData.count_child_active1p)}/
									{statData.count_child_1p}
									<span>{countActive}</span>
								</div>
								<div className={s.sliderBottom}>
									<div className={s.sliderVolume}>{countChild1p}</div>
									<div className={s.sliderLines}>
										<span></span>
									</div>
								</div>
								<div className={`${s.sliderBg} ${s.sliderBg02}`}></div>
							</div>
						</SwiperSlide>

						{/* Count Child */}
						<SwiperSlide>
							<div className={s.sliderItem}>
								<div className={s.sliderTop}>
									<div className={s.sliderLogo}>
										<img src={slider_logo} alt="slider_logo" />
									</div>
									<div className={s.sliderDate}>{monthName}</div>
								</div>
								<div className={`${s.sliderRate} ${s.sliderRateGreen}`}>
									{formatNumber(statData.count_child_active)}/
									{statData.count_child}
									{/*	<span>{countActive}</span>*/}
								</div>
								<div className={s.sliderBottom}>
									<div className={s.sliderVolume}>{countChild}</div>
									<div className={s.sliderLines}>
										<span></span>
									</div>
								</div>
								<div className={`${s.sliderBg} ${s.sliderBg01}`}></div>
							</div>
						</SwiperSlide>

						{/* Bonus Money */}
						<SwiperSlide>
							<div className={`${s.sliderItem} ${s.sliderItemBlue}`}>
								<div className={s.sliderTop}>
									<div className={s.sliderLogo}>
										<img src={slider_logo1} alt="slider_logo" />
									</div>
									<div className={`${s.sliderDate} ${s.sliderDateBlue}`}>
										{monthName}
									</div>
								</div>
								<div className={`${s.sliderRate} ${s.sliderRateGreen}`}>
									{formatNumber(statData.bonus_money)}
									{/*<span>{bonusMoney}</span>*/}
								</div>
								{/*<div className={`${s.sliderRate} ${s.sliderRateBlue}`}>
									{formatNumber(statData.bonus_money)}
									<span>{bonusMoney}</span>
								</div>*/}
								<div className={s.sliderBottom}>
									<div className={s.sliderVolume}>{bonusMoney}</div>
									<div className={s.sliderLines}>
										<span></span>
									</div>
								</div>
								<div className={`${s.sliderBg} ${s.sliderBg03}`}></div>
							</div>
						</SwiperSlide>
					</Swiper>
				</div>
			</div>
		</div>
	);
};

export default SliderSwiper;
